import { useContext, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { CardContent, Card, Typography, CardHeader, Avatar, Tooltip, Grid, Table, TableHead, TableRow, TableBody, TableCell, CircularProgress, Link } from '@mui/material';
import moment from 'moment';
import { IMessage, messageSaveSchema, customerTicketDetailsContext } from '../../CustomerTicketDetailsContext';
import Moment from 'react-moment';
import { MediaThumb, FileIcon, SimecUser, EditIconButton } from 'components';
import { Form, Formik } from 'formik';
import MessageEditor from './MessageEditor';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';


let useStyles = makeStyles()(theme => ({
    root: {
        marginTop: theme.spacing(2),
    },
    header: {
        paddingBottom: 0
    }
}));

interface IProps {
    message: IMessage
}

let Message = ({ message }: IProps) => {
    let { formatMessage } = useIntl();
    let { classes } = useStyles();

    let service = useContext(customerTicketDetailsContext);

    let [editNote, setEditNote] = useState<string | null>(null);


    return (
        <Card className={classes.root}>
            <CardHeader
                classes={{ root: classes.header }}
                avatar={(
                    <Avatar alt={message.username}>
                        {message.username?.charAt(0).toUpperCase()}
                    </Avatar>
                )}
                title={<SimecUser username={message.username} defaultValue={message.userFullName} tooltipPlacement="right" />}
                subheader={(
                    <Tooltip title={`${moment(message.date).format("LLL")}`} placement="right">
                        <span>{moment(message.date).fromNow()}</span>
                    </Tooltip>
                )}
            />
            <CardContent>
                {editNote !== message.messageId &&
                    <Grid container>
                        <Grid item xs>
                            <Typography>
                                <span dangerouslySetInnerHTML={{ __html: message.value }}></span>
                            </Typography>
                        </Grid>

                        {message.isReadOnly === false &&
                            <Grid item>
                                <EditIconButton onClick={() => setEditNote(message.messageId)} />
                            </Grid>
                        }
                        {message.attachments.length > 0 &&
                            <Grid item xs={12}>
                                <Grid container>
                                    {message.attachments
                                        .filter(x => x.isImage === false && x.isVideo === false)
                                        .length > 0 &&
                                        <Grid item xs>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>{formatMessage({ id: LocalizationIds.File })}</TableCell>
                                                        <TableCell>{formatMessage({ id: LocalizationIds.UploadedBy })}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {message.attachments
                                                        .filter(x => x.isImage === false && x.isVideo === false)
                                                        .map((file, index) =>
                                                            <TableRow key={index}>
                                                                <TableCell>
                                                                    <Link
                                                                        component="button"
                                                                        disabled={service.isDownloadingDocument === file.fileId}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            service.downloadAttachment(file.fileId);
                                                                        }}
                                                                    >
                                                                        <FileIcon extension={file.extension} />&nbsp;{file.fileName}
                                                                        {service.isDownloadingDocument === file.fileId && <CircularProgress size={20} />}
                                                                    </Link>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <SimecUser username={file.username} />&nbsp;il <Moment date={file.date} format="LL" />
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                </TableBody>
                                            </Table>
                                        </Grid>
                                    }
                                    {message.attachments
                                        .filter(x => x.isImage === true || x.isVideo === true)
                                        .map(file =>
                                            <Grid item key={file.fileId}>
                                                <MediaThumb
                                                    extension={file.extension}
                                                    mediaId={file.fileId}
                                                    isImage={file.isImage}
                                                    isVideo={file.isVideo}
                                                />
                                            </Grid>
                                        )}
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                }
                {message.isReadOnly === false && editNote === message.messageId &&
                    <Grid container>
                        <Grid item xs={12}>
                            <Formik
                                validationSchema={messageSaveSchema}
                                initialValues={messageSaveSchema.getDefault()}
                                onSubmit={async (values, actions) => {
                                    await service.saveMessage(values);
                                    setEditNote(null);
                                }}
                            >
                                <Form>
                                    <MessageEditor
                                        ticketNumber={service.ticket.ticketNumber}
                                        editMessage={message}
                                        onClose={() => setEditNote(null)}
                                    />
                                </Form>
                            </Formik>
                        </Grid>
                    </Grid>
                }
            </CardContent>
        </Card>
    )
}

export default Message;